<template>
  <div
    class="flex items-center gap-x-3.5 border-t border-y-gray-90 py-4 last:border-b"
  >
    <div class="space-y-2 text-primary">
      <div class="text-lg" v-html="title" />

      <div
        :id="id"
        class="w-full text-sm font-light"
        v-html="content"
      />
<!--   :class="[isExpanded ? '' : 'line-clamp-2 md:line-clamp-1']"   -->
    </div>
<!--    <button
      type="button"
      class="ml-auto shrink-0"
      :aria-label="$t('ariaLabelToggle', { title })"
      :aria-expanded="isExpanded"
      :aria-controls="id"
      @click="toggleExpanded"
    >
      <UiIcon
        class="size-6 transition"
        name="chevron_up"
        :class="[isExpanded ? '' : 'rotate-180']"
      />
    </button>-->
  </div>
</template>

<script setup lang="ts">
defineProps<{ title: string; content: string }>();
const id = useId();

const isExpanded = ref(false);

function toggleExpanded() {
  isExpanded.value = !isExpanded.value;
}
</script>
